// Utility functions for Google Maps integration

declare global {
  interface Window {
    google: any;
    initGoogleMaps: () => void;
  }
}

// Load Google Maps JavaScript API
export const loadGoogleMapsAPI = (): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    // Check if script is already being loaded
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      // Wait for the existing script to load
      const checkLoaded = () => {
        if (window.google && window.google.maps) {
          resolve();
        } else {
          setTimeout(checkLoaded, 100);
        }
      };
      checkLoaded();
      return;
    }

    // Create callback function
    window.initGoogleMaps = () => {
      resolve();
    };

    // Get Google Maps API key from Supabase function
    let apiKey = '';
    try {
      // Import supabase client to get proper auth token
      const { createClient } = await import('@supabase/supabase-js');
      const supabase = createClient(
        'https://tgnzqtzbydztcfhqmxxh.supabase.co',
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRnbnpxdHpieWR6dGNmaHFteHhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyMjAxNjAsImV4cCI6MjA1OTc5NjE2MH0.uk13JA3CBHuu5TzaxCKSjB7iM6Ma3zGTxw3QsdQ2Mts'
      );
      
      console.log('Calling get-google-maps-key function...');
      const { data, error } = await supabase.functions.invoke('get-google-maps-key');
      
      if (error) {
        console.error('Error getting Google Maps API key:', error);
        throw error;
      }
      
      console.log('Google Maps API key response:', data);
      apiKey = data?.key || '';
    } catch (error) {
      console.warn('Failed to get Google Maps API key from server, using environment:', error);
      // Fallback to browser env if available
      apiKey = (window as any).__GOOGLE_MAPS_API_KEY__ || '';
    }

    // Create and load script
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry&callback=initGoogleMaps`;
  script.async = true;
  script.defer = true;
    script.onerror = () => reject(new Error('Failed to load Google Maps API'));
    
    document.head.appendChild(script);
  });
};

// Initialize Google Maps when needed
export const initializeGoogleMaps = async (): Promise<boolean> => {
  try {
    await loadGoogleMapsAPI();
    return true;
  } catch (error) {
    console.error('Failed to initialize Google Maps:', error);
    return false;
  }
};